// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_U0j","cls2":"common-cls2_kAF common-cls1_U0j"};